import TextField from '@mui/material/TextField';
import HoverText from 'modules/documents/components/action-buttons/hoverText';
import React from 'react';

import '../authoring/styles/inlineGallery.sass';

const ImageCaptionInput: React.FunctionComponent<IImageCaptionInputProps> = props => {
    return (
        <div className="caption-container">
            <TextField 
                placeholder="Add caption..."
                size="small"
                variant="standard"
                multiline
                maxRows={2}
                InputProps={{disableUnderline: true, style: {color: "#333333", fontSize: "14px"}}}
                inputProps={{maxLength: 300}}
                className="caption-input"
                value={props.captionText}
                onChange={(e) => props.setCaptionText(e.target.value)}
                onBlur={props.onBlur}
            />

            <HoverText label={props.activeLanguage} labelContainerClassName={"caption-language"}>
                You are currently adding a caption in this language.
            </HoverText>
        </div>
    );
}

type IImageCaptionInputProps = {
    activeLanguage: string;
    captionText: string;
    setCaptionText: (toSet: string) => void;
    onBlur: () => void;
}

export default (ImageCaptionInput)